/* eslint-disable */
import React, { useEffect, useState } from "react";
// ANT DESIGN COMPONENTS
import { Spin, Input } from "antd";
// NAVIGATION
import { useLocation } from "react-router-dom";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// FONT AWESOME LIBRARY AND ICONS
import {
	faNetworkWired,
	faPlugCircleCheck,
	faUserSecret,
} from "@fortawesome/free-solid-svg-icons";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import {
	updateOpenModalCreateNewAdapter,
	updateAdapter,
} from "../../../redux/adapters/adapterSlice";
// CUSTOM HOOKS
import useGetOneAdapter from "../../../customHooks/GET_requests/useGetOneAdapter";
import usePutAdapter from "../../../customHooks/PUT_requests/usePutAdapter";
// COMPONENTS
import FormInputBooleanSwitch from "../../components/form/FormInputBooleanSwitch";
import FormInputText from "../../components/form/FormInputText";
import FormSelectLiftType from "../../components/form/FormSelectLiftType";
import FormSelectAdapterType from "../../components/form/FormSelectAdapterType";
import FormSelectAuthType from "../../components/form/FormSelectAuthType";
import FormInputIPandPort from "../../components/form/FormInputIPandPort";
import FormInputNumber from "../../components/form/FormInputNumber";
import FormSelectProtocolType from "../../components/form/FormSelectProtocolType";
import FormSelectProductType from "../../components/form/FormSelectProductType";
import FormSelectLeadingZeroes from "../../components/form/FormSelectLeadingZeroes";
import DrawerRowDivider from "../../components/drawer/DrawerRowDivider";
import FormSelectProtocolTypeEmun from "../../components/form/FormSelectProtocolTypeEmun";
import CdoBacnet from "./CDO/BACNET/CdoBacnet";
import CdoOpcPage from "./CDO/OPC/CdoOpcPage";
import CdoSequentPage from "./CDO/SEQUENT/CdoSequentPage";
import CdoModbusPage from "./CDO/MODBUS/CdoModbusPage";
// UTILS
import { extractCdoState } from "./extractCdoState";
// INTERFACES
import { RootState } from "../../../app/store";
import {
	AdapterInterface,
	AdapterCdoMceInterface,
	AdapterCdoLn1Interface,
} from "../../../interfaces/Adapter.interface";
import { AdapterCdoModbusInterface } from "../../../interfaces/AdapterCdoModbus.interface";
import { AdapterCdoOpcInterface } from "../../../interfaces/AdapterCdoOpc.interface";
import {
	AdapterBacnetInterface,
	BacnetBankMapping,
} from "../../../interfaces/AdapterCdoBacnet.interface";
import { AdapterCdoSequentInterface } from "../../../interfaces/AdapterCdoSequent.interface";
import { LiftType } from "../../../interfaces/Lift.interface";
// CONSTANTS
import {
	BLANK_ADAPTER,
	BLANK_ADAPTER_CDO_MCE,
	BLANK_ADAPTER_CDO_MODBUS,
	BLANK_ADAPTER_CDO_LN1,
	BLANK_ADAPTER_CDO_OPC,
	BLANK_ADAPTER_CDO_SEQUENT,
} from "../../../constants/adapter";

export default function AdaptersEdit() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const location = useLocation();
	const adapterId = new URLSearchParams(location.search).get("idAdapter");
	const dispatch = useDispatch();
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [adapter, setAdapter] = useState<AdapterInterface>({
		...BLANK_ADAPTER,
	});
	const [cdoMce, setCdoMce] = useState<AdapterCdoMceInterface>({
		...BLANK_ADAPTER_CDO_MCE,
	});
	const [cdoModbus, setCdoModbus] = useState<AdapterCdoModbusInterface>({
		...BLANK_ADAPTER_CDO_MODBUS,
	});
	const [cdoSequent, setCdoSequent] = useState<AdapterCdoSequentInterface>({
		...BLANK_ADAPTER_CDO_SEQUENT,
	});
	const [cdoOpc, setCdoOpc] = useState<AdapterCdoOpcInterface>({
		...BLANK_ADAPTER_CDO_OPC,
	});
	const [cdoBacnet, setCdoBacnet] = useState<AdapterBacnetInterface[]>([]);
	const [bacnetBankMappings, setBacnetBankMappings] = useState<
		BacnetBankMapping[]
	>([]);
	const [cdoLn1, setCdoLn1] = useState<AdapterCdoLn1Interface>({
		...BLANK_ADAPTER_CDO_LN1,
	});
	const [jsonStringDictionary, setJsonStringDictionary] = useState<string>("");
	const [jsonStringInterface, setJsonStringInterface] = useState<string>("");
	const [addBacnetCdo, setAddBacnetCdo] = useState<boolean>(false);

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { theme } = useSelector((state: RootState) => state.home);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */
	const { adapter: adapterHook, isLoadingGetOneAdapter } = useGetOneAdapter({
		id: adapterId ?? "",
	});
	const {
		putAdapter,
		isLoadingPutAdapter,
		isSuccessPutAdapter,
		isErrorPutAdapter,
	} = usePutAdapter();

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onClickClose = () => {
		setAdapter({ ...BLANK_ADAPTER });
		setCdoMce({ ...BLANK_ADAPTER_CDO_MCE });
		setCdoModbus({ ...BLANK_ADAPTER_CDO_MODBUS });
		setCdoOpc({ ...BLANK_ADAPTER_CDO_OPC });
		setCdoLn1({ ...BLANK_ADAPTER_CDO_LN1 });
		setCdoSequent({ ...BLANK_ADAPTER_CDO_SEQUENT });
		setBacnetBankMappings([]);
		setJsonStringDictionary("");
		setJsonStringInterface("");
		dispatch(updateOpenModalCreateNewAdapter(false));
		dispatch(updateAdapter({ ...BLANK_ADAPTER }));
	};

	const onClickSave = async () => {
		const copy: AdapterInterface = { ...adapter };
		if (copy.protocol_type.toLowerCase() === "mce") {
			copy.cdo_input = cdoMce;
		} else if (copy.protocol_type.toLowerCase() === "modbus") {
			copy.cdo_input = cdoModbus;
		} else if (copy.protocol_type.toLowerCase() === "opc") {
			copy.cdo_input = cdoOpc;
		} else if (copy.protocol_type.toLowerCase() === "sequent") {
			copy.cdo_input = cdoSequent;
		} else if (copy.protocol_type.toLowerCase() === "ln1") {
			copy.cdo_input = cdoLn1;
		} else {
			copy.cdo_input = {};
		}
		copy.bacnet_config = null;
		if (!copy.offset_mapping) {
			copy.offset_mapping = [];
		}
		putAdapter(copy);
	};

	const onChangeFormValueCdoMce = (
		newValue: string | number,
		variableName: string,
	) => {
		const copy: AdapterCdoMceInterface = structuredClone(cdoMce);
		if (variableName === "idl_file" && typeof newValue === "string") {
			copy.idl_file = newValue;
		} else if (
			variableName === "reporting_address" &&
			typeof newValue === "string"
		) {
			copy.event_reporting_address = newValue;
		} else if (
			variableName === "mapping_data" &&
			typeof newValue === "string"
		) {
			copy.event_mapping_data = newValue;
		} else if (
			variableName === "mapping_file" &&
			typeof newValue === "string"
		) {
			copy.event_mapping_file = newValue;
		}
		setCdoMce(copy);
	};

	const onChangeAddBacnetCdo = (newValue: boolean) => {
		setAddBacnetCdo(newValue);
	};

	const onChangeFormValueCdoLn1 = (
		newValue: boolean | number,
		variableName: string,
	) => {
		const copy: AdapterCdoLn1Interface = structuredClone(cdoLn1);
		if (variableName === "crc_override" && typeof newValue === "boolean") {
			copy.crc_override = newValue;
		} else if (
			variableName === "should_filter_duplicates" &&
			typeof newValue === "boolean"
		) {
			copy.should_filter_duplicates = newValue;
		} else if (
			variableName === "allowed_messages" &&
			typeof newValue === "number"
		) {
			copy.allowed_messages = newValue;
		} else if (
			variableName === "from_device_serial" &&
			typeof newValue === "number"
		) {
			copy.terminating_zeroes_expected.from_device_serial = newValue;
		} else if (variableName === "refresh_all" && typeof newValue === "number") {
			copy.terminating_zeroes_expected.refresh_all = newValue;
		} else if (variableName === "set_one_bit" && typeof newValue === "number") {
			copy.terminating_zeroes_expected.set_one_bit = newValue;
		} else if (
			variableName === "reinitialize_all_devices" &&
			typeof newValue === "number"
		) {
			copy.terminating_zeroes_expected.reinitialize_all_devices = newValue;
		} else if (
			variableName === "set_one_byte" &&
			typeof newValue === "number"
		) {
			copy.terminating_zeroes_expected.set_one_byte = newValue;
		} else if (variableName === "rvu" && typeof newValue === "number") {
			copy.terminating_zeroes_expected.rvu = newValue;
		} else if (
			variableName === "rvu_heartbeat" &&
			typeof newValue === "number"
		) {
			copy.terminating_zeroes_expected.rvu_heartbeat = newValue;
		}
		setCdoLn1(copy);
	};

	const onChangeFormValueLiftType = (newValue: LiftType) => {
		setAdapter((prev: AdapterInterface) => ({ ...prev, lift_type: newValue }));
	};

	const onChangeFormValue = (
		newValue: string | number,
		variableName: string,
	) => {
		const copy: AdapterInterface = structuredClone(adapter);
		if (variableName === "name" && typeof newValue === "string") {
			copy.name = newValue;
		} else if (variableName === "type" && typeof newValue === "string") {
			copy.type = newValue;
		} else if (variableName === "version" && typeof newValue === "string") {
			copy.version = newValue;
		} else if (
			variableName === "socket_address" &&
			typeof newValue === "string"
		) {
			copy.socket_address = newValue;
		} else if (variableName === "auth_type" && typeof newValue === "string") {
			copy.auth_type = newValue;
		} else if (variableName === "auth_type" && typeof newValue === "string") {
			copy.auth_type = newValue;
		} else if (variableName === "units" && typeof newValue === "number") {
			copy.units = newValue;
		} else if (variableName === "floors" && typeof newValue === "number") {
			copy.floors = newValue;
		}
		setAdapter(copy);
	};

	const onChangeFormValueAuthCredentials = (
		newValue: string,
		variableName: string,
	) => {
		const copy: AdapterInterface = structuredClone(adapter);
		copy.auth_credentials[variableName] = newValue;
		setAdapter(copy);
	};

	const onChangeProtocolValue = (
		protocolId: string,
		protocolName: string,
		protocolDefaultInterface: string,
	) => {
		const copy: AdapterInterface = structuredClone(adapter);
		copy.protocol_id = protocolId;
		copy.interface = JSON.parse(protocolDefaultInterface);
		setAdapter(copy);
	};

	const onChangeProtocolType = (newValue: string) => {
		const copy: AdapterInterface = structuredClone(adapter);
		copy.protocol_type = newValue;
		setAdapter(copy);
	};

	const onChangeProductTypeValue = (newValue: number) => {
		const copy: AdapterCdoMceInterface = structuredClone(cdoMce);
		copy.product_type = newValue;
		setCdoMce(copy);
	};

	const onChangeLeadingZeroesValue = (id: string) => {
		const copy: AdapterInterface = structuredClone(adapter);
		copy.leading_zeroes_id = id;
		setAdapter(copy);
	};

	const isValidJSON = (str: string) => {
		try {
			JSON.parse(str);
			return true;
		} catch (e) {
			return false;
		}
	};

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		onClickClose();
	}, [isSuccessPutAdapter, isErrorPutAdapter]);

	useEffect(() => {
		if (isValidJSON(jsonStringDictionary)) {
			const copy: AdapterInterface = structuredClone(adapter);
			copy.dictionary = JSON.parse(jsonStringDictionary);
			setAdapter(copy);
		}
	}, [jsonStringDictionary]);

	useEffect(() => {
		if (isValidJSON(jsonStringInterface)) {
			const copy: AdapterInterface = structuredClone(adapter);
			copy.interface = JSON.parse(jsonStringInterface);
			setAdapter(copy);
		}
	}, [jsonStringInterface]);

	useEffect(() => {
		if (adapterHook && adapterHook.id) {
			setAdapter(adapterHook);
			const cdo = extractCdoState(adapterHook);
			if (cdo.cdoMce) setCdoMce(cdo.cdoMce);
			if (cdo.cdoLn1) setCdoLn1(cdo.cdoLn1);
			if (cdo.cdoSequent) setCdoSequent(cdo.cdoSequent);
			if (cdo.cdoOpc) setCdoOpc(cdo.cdoOpc);
			setJsonStringDictionary(JSON.stringify(adapterHook.dictionary));
			setJsonStringInterface(JSON.stringify(adapterHook.interface));
		}
	}, [adapterHook]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Spin spinning={isLoadingPutAdapter || isLoadingGetOneAdapter}>
			{/** ------------------------------------------------------------- */}
			{/** ADAPTER FORM  */}
			<DrawerRowDivider icon={faPlugCircleCheck} title='Adapter' />
			<div className='generalStyles__flexWrap '>
				{/** ID */}
				<div
					className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
				>
					<div className='generalStyles__width100'>
						<div>
							<p>
								<span className='generalStyles__inputFlexRequired'>*</span>
								ID
							</p>
						</div>
						<div style={{ marginTop: "-10px" }}>
							<Input
								className='generalStyles__input'
								size='small'
								value={adapter.id}
								disabled
							/>
						</div>
					</div>
				</div>
				{/** COMPONENTS FORM - INPUT NAME */}
				<div
					className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
				>
					<FormInputText
						inputValue={adapter.name}
						inputLabelName={t("general.name")}
						inputOnChange={onChangeFormValue}
						inputVariableName='name'
						isRequired
						disabledInput={false}

					/>
				</div>
				{/** COMPONENTS FORM - SELECT LIFT TYPE */}
				<div
					className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
				>
					<FormSelectLiftType
						inputValue={adapter.lift_type}
						inputOnChange={onChangeFormValueLiftType}

					/>
				</div>
				{/** COMPONENTS FORM - SELECT ADAPTER TYPE */}
				<div
					className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
				>
					<FormSelectAdapterType
						inputValue={adapter.type}
						inputOnChange={onChangeFormValue}
						inputLabelName='Adapter Type'
						inputVariableName='type'

					/>
				</div>
				{/** COMPONENTS FORM - INPUT VERSION */}
				<div
					className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
				>
					<FormInputText
						inputValue={adapter.version}
						inputLabelName={t("adapter.version")}
						inputOnChange={onChangeFormValue}
						inputVariableName='version'
						isRequired
						disabledInput={false}

					/>
				</div>
				{/** COMPONENTS FORM - INPUT SOCKET ADDRESS */}
				<div
					className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
				>
					<FormInputIPandPort
						inputValue={adapter.socket_address}
						inputLabelName={t("edgeManagement.channels.socketAddress")}
						inputOnChange={onChangeFormValue}
						inputVariableName='socket_address'

					/>
				</div>
				{/** COMPONENTS FORM - UNITS */}
				<div
					className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
				>
					<FormInputNumber
						inputValue={adapter.units}
						inputOnChange={onChangeFormValue}
						inputLabelName='Units'
						inputVariableName='units'

					/>
				</div>
				{/** COMPONENTS FORM - FLOORS */}
				<div
					className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
				>
					<FormInputNumber
						inputValue={adapter.floors}
						inputOnChange={onChangeFormValue}
						inputLabelName='Floors'
						inputVariableName='floors'

					/>
				</div>
				{/** COMPONENTS FORM - LEADING ZEROES */}
				<div
					className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
				>
					<FormSelectLeadingZeroes
						inputValue={adapter.leading_zeroes_id}
						inputOnChange={onChangeLeadingZeroesValue}
						inputLabelName={t("general.leadingZeroes")}

					/>
				</div>
				{/** COMPONENTS FORM - BACNET CDO */}
				<div
					className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
				>
					<FormInputBooleanSwitch
						value={addBacnetCdo}
						onChangeSwitch={onChangeAddBacnetCdo}
						labelName='CDO Bacnet'
						variableName=''
						isRequired
						disabledInput={false}

					/>
				</div>
			</div>

			{/** ------------------------------------------------------------- */}
			{/** AUTH TYPE INFORMATION  */}
			<DrawerRowDivider
				icon={faUserSecret}
				title={t("adapter.authTypeInformation")}
			/>
			<div className='generalStyles__flexWrap'>
				{/** COMPONENTS FORM - SELECT AUTH TYPE */}
				<div
					className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
				>
					<FormSelectAuthType
						inputValue={adapter.auth_type}
						inputOnChange={onChangeFormValue}
						inputLabelName='Auth Type'
						inputVariableName='auth_type'

					/>
				</div>
				{/** COMPONENTS FORM - INPUT AUTH TYPE USERNAME */}
				<div
					className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
				>
					<FormInputText
						inputValue={adapter.auth_credentials.username}
						inputLabelName={t("general.userName")}
						inputOnChange={onChangeFormValueAuthCredentials}
						inputVariableName='username'
						isRequired
						disabledInput={false}

					/>
				</div>
				{/** COMPONENTS FORM - INPUT AUTH TYPE PASSWORD */}
				<div
					className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
				>
					<FormInputText
						inputValue={adapter.auth_credentials.password}
						inputLabelName={t("general.password")}
						inputOnChange={onChangeFormValueAuthCredentials}
						inputVariableName='password'
						isRequired
						disabledInput={false}

					/>
				</div>
			</div>
			{/** ------------------------------------------------------------- */}
			{/** PROTOCOL  */}
			<DrawerRowDivider icon={faNetworkWired} title='Protocol' />
			<div className='generalStyles__flexWrap'>
				{/** COMPONENTS FORM - PROTOCOL */}
				<div
					className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
				>
					<FormSelectProtocolType
						inputValue={adapter.protocol_id}
						inputOnChange={onChangeProtocolValue}
						inputLabelName={t("general.protocol")}

					/>
				</div>
				{/** COMPONENTS FORM - PROTOCOL  TYPE NAME ENUM */}
				<div
					className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
				>
					<FormSelectProtocolTypeEmun
						value={adapter.protocol_type}
						onChangeProtocolTypeEnum={onChangeProtocolType}
						disabledInput={false}

					/>
				</div>
			</div>
			{["ln1", "mce"].includes(adapter.protocol_type.toLowerCase()) && (
				<>
					{/** ************************************************* */}
					{/** COMPONENT DRAWER DIVIDER */}
					<DrawerRowDivider
						icon={faPlugCircleCheck}
						title={adapter.protocol_type.toUpperCase()}
					/>
					{/** ------------------------------------------------------------- */}
					{/** ADAPTER FORM  */}
					<div className='generalStyles__flexWrap'>
						{/** COMPONENTS FORM - CRC OVERRIDE */}
						{adapter.protocol_type.toLowerCase() === "ln1" && (
							<div
								className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
							>
								<FormInputBooleanSwitch
									value={cdoLn1.crc_override}
									onChangeSwitch={onChangeFormValueCdoLn1}
									labelName={t("general.crcOverride")}
									variableName='crc_override'
									isRequired
									disabledInput={false}

								/>
							</div>
						)}
						{/** COMPONENTS FORM - SHOULD FILTER DUPLICATES */}
						{adapter.protocol_type.toLowerCase() === "ln1" && (
							<div
								className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
							>
								<FormInputBooleanSwitch
									value={cdoLn1.should_filter_duplicates}
									onChangeSwitch={onChangeFormValueCdoLn1}
									labelName={t("general.shouldFilterDuplicates")}
									variableName='should_filter_duplicates'
									isRequired
									disabledInput={false}

								/>
							</div>
						)}
						{/** COMPONENTS FORM - ALLOWED MESSAGES */}
						{adapter.protocol_type.toLowerCase() === "ln1" && (
							<div
								className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
							>
								<FormInputNumber
									inputValue={cdoLn1.allowed_messages}
									inputOnChange={onChangeFormValueCdoLn1}
									inputLabelName={t("general.allowedMessages")}
									inputVariableName='allowed_messages'

								/>
							</div>
						)}
						{/** COMPONENTS FORM - */}
						{adapter.protocol_type.toLowerCase() === "ln1" && (
							<div
								className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
							>
								<FormInputNumber
									inputValue={
										cdoLn1.terminating_zeroes_expected.from_device_serial
									}
									inputOnChange={onChangeFormValueCdoLn1}
									inputLabelName={t("general.fromDeviceSerial")}
									inputVariableName='from_device_serial'

								/>
							</div>
						)}
						{/** COMPONENTS FORM - */}
						{adapter.protocol_type.toLowerCase() === "ln1" && (
							<div
								className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
							>
								<FormInputNumber
									inputValue={cdoLn1.terminating_zeroes_expected.refresh_all}
									inputOnChange={onChangeFormValueCdoLn1}
									inputLabelName={t("general.refreshAll")}
									inputVariableName='refresh_all'

								/>
							</div>
						)}
						{/** COMPONENTS FORM - */}
						{adapter.protocol_type.toLowerCase() === "ln1" && (
							<div
								className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
							>
								<FormInputNumber
									inputValue={cdoLn1.terminating_zeroes_expected.set_one_bit}
									inputOnChange={onChangeFormValueCdoLn1}
									inputLabelName={t("general.setOneBit")}
									inputVariableName='set_one_bit'

								/>
							</div>
						)}
						{/** COMPONENTS FORM - */}
						{adapter.protocol_type.toLowerCase() === "ln1" && (
							<div
								className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
							>
								<FormInputNumber
									inputValue={
										cdoLn1.terminating_zeroes_expected.reinitialize_all_devices
									}
									inputOnChange={onChangeFormValueCdoLn1}
									inputLabelName={t("general.reinitializeAllDevices")}
									inputVariableName='reinitialize_all_devices'

								/>
							</div>
						)}
						{/** COMPONENTS FORM - */}
						{adapter.protocol_type.toLowerCase() === "ln1" && (
							<div
								className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
							>
								<FormInputNumber
									inputValue={cdoLn1.terminating_zeroes_expected.set_one_byte}
									inputOnChange={onChangeFormValueCdoLn1}
									inputLabelName={t("general.setOneByte")}
									inputVariableName='set_one_byte'

								/>
							</div>
						)}
						{/** COMPONENTS FORM - */}
						{adapter.protocol_type.toLowerCase() === "ln1" && (
							<div
								className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
							>
								<FormInputNumber
									inputValue={cdoLn1.terminating_zeroes_expected.rvu}
									inputOnChange={onChangeFormValueCdoLn1}
									inputLabelName={t("general.rvu")}
									inputVariableName='rvu'

								/>
							</div>
						)}
						{/** COMPONENTS FORM - */}
						{adapter.protocol_type.toLowerCase() === "ln1" && (
							<div
								className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
							>
								<FormInputNumber
									inputValue={cdoLn1.terminating_zeroes_expected.rvu_heartbeat}
									inputOnChange={onChangeFormValueCdoLn1}
									inputLabelName={t("general.rvuHeartBeat")}
									inputVariableName='rvu_heartbeat'

								/>
							</div>
						)}
						{/** COMPONENTS FORM - IDL File */}
						{adapter.protocol_type.toLowerCase() === "mce" && (
							<div
								className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
							>
								<FormInputText
									inputValue={cdoMce.idl_file}
									inputLabelName={t("general.idlFile")}
									inputOnChange={onChangeFormValueCdoMce}
									inputVariableName='idl_file'
									isRequired
									disabledInput={false}

								/>
							</div>
						)}
						{/** COMPONENTS FORM - PRODUCT TYPE */}
						{adapter.protocol_type.toLowerCase() === "mce" && (
							<div
								className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
							>
								<FormSelectProductType
									inputValue={cdoMce.product_type}
									inputOnChange={onChangeProductTypeValue}
									inputLabelName={t("general.productType")}

								/>
							</div>
						)}
						{/** COMPONENTS FORM - Reporting address */}
						{adapter.protocol_type.toLowerCase() === "mce" && (
							<div
								className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
							>
								<FormInputText
									inputValue={cdoMce.event_reporting_address}
									inputLabelName={t("general.reportingAddress")}
									inputOnChange={onChangeFormValueCdoMce}
									inputVariableName='reporting_address'
									isRequired
									disabledInput={false}

								/>
							</div>
						)}
						{/** COMPONENTS FORM - Event Mapping File */}
						{adapter.protocol_type.toLowerCase() === "mce" && (
							<div
								className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
							>
								<FormInputText
									inputValue={cdoMce.event_mapping_file}
									inputLabelName={t("general.eventMappingFile")}
									inputOnChange={onChangeFormValueCdoMce}
									inputVariableName='mapping_file'
									isRequired
									disabledInput={false}

								/>
							</div>
						)}
						{/** COMPONENTS FORM - Event Mapping Data */}
						{adapter.protocol_type.toLowerCase() === "mce" && (
							<div
								className={`generalStyles__pageInputContainer generalStyles__box__page__${theme}`}
							>
								<FormInputText
									inputValue={cdoMce.event_mapping_data}
									inputLabelName={t("general.eventMappingData")}
									inputOnChange={onChangeFormValueCdoMce}
									inputVariableName='mapping_data'
									isRequired
									disabledInput={false}

								/>
							</div>
						)}
					</div>
					<br />
				</>
			)}
			{/** COMPONENTS FORM - OPC */}
			{adapter.protocol_type.toLowerCase() === "opc" && (
				<CdoOpcPage setCdo={setCdoOpc} cdoValue={cdoOpc} />
			)}
			{/** COMPONENTS FORM - MODBUS */}
			{adapter.protocol_type.toLowerCase() === "modbus" && (
				<CdoModbusPage setCdo={setCdoModbus} cdoValue={cdoModbus} />
			)}
			{/** COMPONENTS FORM - BACNET */}
			{(adapter.protocol_type.toLowerCase() === "bacnet" || addBacnetCdo) && (
				<CdoBacnet
					setCdo={setCdoBacnet}
					cdoValue={cdoBacnet}
					bankMappings={bacnetBankMappings}
					setBankMappings={setBacnetBankMappings}
				/>
			)}
			{/** COMPONENTS FORM - INPUT TEXT CDO SEQUENT */}
			{adapter.protocol_type.toLowerCase() === "sequent" && (
				<CdoSequentPage setCdo={setCdoSequent} cdoValue={cdoSequent} />
			)}
		</Spin>
	);
}
